import { Component, OnInit, Input, HostBinding, ElementRef } from '@angular/core';

@Component({
  selector: 'context-menu',
  templateUrl: './context-menu.component.html',
  styleUrls: ['./context-menu.component.css']
})
export class ContextMenuComponent implements OnInit {

  @Input() @HostBinding('class.open') open: boolean = false;

  constructor(private eleRef: ElementRef) { }

  ngOnInit() {
    this.eleRef.nativeElement.parentElement.onclick = (evt) => {
      if (this.targetIsNotContextMenu(evt.target)) {
        this.open = !this.open;
      }
    };
  }

  targetIsNotContextMenu(target: HTMLElement) {
    return !target.classList.contains("context-menu");
  }

}
